import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link'
import Helmet from 'react-helmet';;
import Image from 'gatsby-image';
import SEO from '../components/SEO';
import config from '../../config/website';


import BannerImage from '../components/CaseStudy/BannerImage';
import ImageAndText from '../components/CaseStudy/ImageAndText';
import Quote from '../components/CaseStudy/Quote';
import SmallImages from '../components/CaseStudy/SmallImages';
import Text from '../components/CaseStudy/Text';
import SideInfo from '../components/CaseStudy/SideInfo';
import TwoImages from '../components/CaseStudy/TwoImages';
import Hero from '../components/CaseStudy/Hero';
import TextSnippet from '../components/CaseStudy/TextSnippet';


const renderPrismicSlice = ({ slice_type, primary = {}, items }, key) => {
  if (items) primary.items = items;

  switch (slice_type) {
    case 'text': return <Text {...primary} key={key} />;
    case '2_images': return <TwoImages {...primary} key={key} />;
    case 'quote': return <Quote {...primary} key={key} />;
    case 'side_info': return <SideInfo {...primary} key={key} />;
    case 'banner_with_caption': return <BannerImage {...primary} key={key} />;
    case 'image_and_text': return <ImageAndText {...primary} key={key} />;
    case 'small_images_w__text': return <SmallImages {...primary} key={key} />;
    case 'text_snippet': return <TextSnippet {...primary} key={key} />;
    default: return null;
  }
};

const CaseTemplate = ({ data: { prismicCaseStudy: caseNode } }) => {
  const { body, ...hero } = caseNode.data;
  const { data, uid: slug } = caseNode;
 // console.log(slug, caseNode.uid, caseNode);

  return (
    <React.Fragment>
      <Helmet title={`${data.title.text} | ${config.siteTitle}`} />
      <SEO caseNode={caseNode} casePath={caseNode.uid} caseSEO />


      <div className="template">
        <div className="template__wrapper">
          <Hero {...hero} slug={slug} />

          {body && body.map(renderPrismicSlice)}

          <div className="template__footer">
              <div className="btn"> <Link to="/">More profiles</Link> </div>
          </div>

        </div>
      </div>
   </React.Fragment>
  );
};

export default CaseTemplate;

CaseTemplate.propTypes = {
  data: PropTypes.shape({
    prismicCaseStudy: PropTypes.object.isRequired,
  }).isRequired,
};

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query CaseBySlug($uid: String!) {
    prismicCaseStudy(uid: { eq: $uid }) {
      uid
      data {
        header_image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 940, maxHeight: 700, quality: 100) {
                ...GatsbyImageSharpSizes_noBase64
              }
              resize {
                src
              }
            }
          }
        }
        excerpt
        title {
          text
        }
        subtitle {
          text
        }
        words {
          text
        }
        credits {
          html
        }
        date(formatString: "MMMM D YYYY")
        body {
          ... on PrismicCaseStudyBodyBannerWithCaption {
            ...BannerFragment
          }

          ... on PrismicCaseStudyBodyText {
            ...TextFragment
          }

          ... on PrismicCaseStudyBodyQuote {
            ...QuoteFragment
          }

          ... on PrismicCaseStudyBody2Images {
            ...TwoImageFragment
          }

          ... on PrismicCaseStudyBodySideInfo {
            ...SideInfoFragment
          }

          ... on PrismicCaseStudyBodySmallImagesWText {
            ...SmallImagesFragment
          }

          ... on PrismicCaseStudyBodyImageAndText {
            ...ImageAndTextFragment
          }

          ... on PrismicCaseStudyBodyTextSnippet {
            ...TextSnippetFragment
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/case.jsx